import { render, staticRenderFns } from "./WizardContentDateInput.vue?vue&type=template&id=5b10c67f&scoped=true&"
import script from "./WizardContentDateInput.vue?vue&type=script&lang=ts&"
export * from "./WizardContentDateInput.vue?vue&type=script&lang=ts&"
import style0 from "./WizardContentDateInput.vue?vue&type=style&index=0&id=5b10c67f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b10c67f",
  null
  
)

export default component.exports